import { API_URL } from '../core/constants';

import { ApolloClient, InMemoryCache, defaultDataIdFromObject } from '@apollo/client';
import { reactiveFeedbackMessage } from './apollo-cache';

export default new ApolloClient({
  credentials: 'include',
  uri: `${API_URL}/graphql`,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          feedbackMessage: {
            read() {
              return reactiveFeedbackMessage();
            },
          },
        },
      },
    },
    dataIdFromObject(responseObject) {
      switch (responseObject.__typename) {
        case 'SeasonParticipantInfo':
          return `SeasonParticipantInfo:${responseObject.seasonParticipantId}`;
        case 'Form':
          return `Form:${responseObject.isReg2 ? 'Reg2' : 'Reg1'}_${responseObject.id}`;
        default:
          return defaultDataIdFromObject(responseObject);
      }
    },
  }),
});
